/* global $, JitsiMeetJS */
import { ReloadPopup } from '../public/ReloadPopup.js';
import { UserLogger } from './UserLogger.js';
import { VeedoUserLogin } from './VeedoUserLogin.js';

/* Global options that should be set:
   subdomain
   domane
   roomName
*/

// AmbiguousHasProperty is a stupid function developed
// to solve a bad design decision where 'noChat' and 'noLogin'
// were being used to determine whether login or chat are supported.
// This function, along with the noChat and noLogin values will
// be removed, but for now we're providing this to handle legacy situations.
function AmbiguousHasProperty(config, prop) {
    let notProp = prop.substr(0,1).toUpperCase() + prop.substr(1).toLowerCase();
    return config  // if no config, we don't have chat
        && !(config.hasOwnProperty(notProp) && config[notProp]) // if we have a noChat property of true => no chat
        && (!config.hasOwnProperty(prop) || config[prop]);  // if we have a chat property of false => no chat
}

// stripStar removes leading asterisks from the input
function stripStar(n) {    
    if (!n) {
        return ``;
    }    
    do {
        n = n.trim();
        if (n.startsWith(`*`)) {
            n = n.substr(1);
        }
    } while (n && n.startsWith(`*`))
    return n;
}

//const key = "features/base/settings";
const key = "player/base/settings";
function changeName(firstRun=true, failed=false) {
    console.log(`veedoplayer: veedoConfig = `, veedoConfig);
    if (!AmbiguousHasProperty(veedoConfig,`login`)) {
        console.log(`Exiting veedoplayer.changeName: veedoConfig.login == false`);
        // ensure that if we do not have to login the player can still start
        document.userNamed = true;
        dispatchUserDetail({});
        return;
    }
    if (firstRun) {
        let queryParams = new URLSearchParams(window.location.search);
        let args = new Object();
        for (let [k,v] of queryParams.entries()) {
            args[k] = v.trim();
        }
        if (args.name && args.reload) {
            veedoUserLogsIn(args);
        } else {
            console.log(`veedoConfig = `, veedoConfig);
            console.log(`creating VeedoUserLogin with veedoConfig.config.login = `, veedoConfig.config.login);
            if (veedoConfig.config.login) {
                new VeedoUserLogin(veedoUserLogsIn, veedoConfig.config.login, failed);
            }
        }
        return;
    }
    console.error(`changeName not supported`);
}

function dispatchUserDetail(detail){
    document.body.dispatchEvent(new CustomEvent(`veedo-user-name`, {
        bubbles: true, 
        composed: true, 
        detail: detail
    }));
    document.userNamed = true;
}

function veedoUserLogsIn(userSettings) {
    console.log(`veedoUserLogsIn - userSettings = `, userSettings);
    // console.log(`typeof userSettings.name = `, typeof userSettings.name);
    // userSettings.name = stripStar(userSettings.name);
    let userName = userSettings.name ?? userSettings.full_name;   // null coalescing operator
    if (userSettings.firstname && userSettings.surname) {
        userName = userSettings.firstname + " " + userSettings.surname;
    }
    if (!userSettings.name) {   // set the username if it's not set
        userSettings.name = userName;
    }
    //erSettings.name = userName;
    if (userName && userName != ""){
        let settings = localStorage[key];
        if (!settings) {
            settings = {};
        } else {
            settings = JSON.parse(settings);
        }
        if (ReloadPopup) {
            // console.log(`creating ReloadPopup with `, userSettings);
            new ReloadPopup(userSettings);
        } else {
            console.log(`No ReloadPopup found`);
        }
        if (!userName) {
            console.error(`NO name property found in userSettings`);
            alert(`no name value received in userSettings`);
            debugger;
        }
        // this needs to be global!
        name = "*" + stripStar(userName); // 'name' is the only value we MUST HAVE in userSettings
        // console.log(`set username = ${name}`);
        settings["displayName"] = name;
        localStorage[key] = JSON.stringify(settings);
        const sp = $("#namespan");
        sp.html(name);
        userSettings.room = roomName;
        // console.log(`sending veedo-user-name with `, userSettings);
        dispatchUserDetail(userSettings);
        if (room) {
            room.setDisplayName(name);
        }
    } else {
        console.error(`veedoUserLogsIn BUT NO NAME FOUND`);
    }
}

var VeedoChat = {
    connection: null,
    room: null,
    nickname: null,
    myuuid: null,

    NS_MUC: "http://jabber.org/protocol/muc",
    NS_NICK: "http://jabber.org/protocol/nick",

    joined: null,
    participants: null,
    nicks: null,    

    on_presence: function (presence) {        
        console.log(`veedoplayer.js - VeedoChat::on_presence(..) presence=`, presence);
        var $presence = $(presence);
        var from = $presence.attr('from');
        var troom = Strophe.getBareJidFromJid(from);

        console.log(`veedoplayer.js VeedoChat::on_presence: troom=${troom} == ${VeedoChat.room}, VeedoChat.joined=${VeedoChat.joined}`);

        // make sure this presence is for the right room
        if (troom === VeedoChat.room) {
            var nick = Strophe.getResourceFromJid(from);
            VeedoChat.checkNick(nick, presence);
            if ($presence.attr('type') === 'error' && !VeedoChat.joined) {
                // is this an auth'd room?
                var errsub = $presence.children('error');
                if (errsub) {
                    console.log(`veedoplayer.js VeedoChat::on_presence: errsub = `, errsub);
                    if (errsub.attr("type")=='auth') {
                        if (errsub.attr("code") == "401"){
                            console.log("requires a password");
                        } else  if (errsub.attr("code") == "407"){
                            console.log("This room requires auth");
                            var lobby = $presence.children("lobbyroom").text();
                            if (lobby != ""){
                                console.log("Send them to the Lobby: "+ lobby);
                                var parts = lobby.split("@");
                                VeedoChat.lobby = true;
                                VeedoChat.lobbyroom = lobby;
                                sendPresence(lobby);
                            }
                        }
                    } else if (errsub.attr("code")=="409") {
                        console.log(`veedoplayer.js: VeedoChat::on_presence() - CODE 409 CONFLICT errsub = `, errsub);
                        // set the reconnect after disconnection flag
                        VeedoChat.reconnect_after_disconnection = true;
                        VeedoChat.connection.disconnect();
                    } else {
                        console.log(`veedoplayer.js: VeedoChat::on_presence() - errsub = `, errsub);
                    }
                } else {
                    // error joining room; reset app
                    console.log(`veedoplayer.js: VeedoChat::on_presence() - resetting w/ disconnect`);
                    VeedoChat.connection.disconnect();
                }
            } else if (!VeedoChat.participants[nick] &&
                $presence.attr('type') !== 'unavailable') {
                // add to participant list   
                var user_jid = $presence.find('item').attr('jid');
                VeedoChat.participants[nick] = user_jid || true;

                //if (VeedoChat.joined) {
                    $(document).trigger('user_joined', nick);
                //}
            } else if (VeedoChat.participants[nick] &&
                        $presence.attr('type') === 'unavailable') {
                $(document).trigger('user_left', nick);
            }

            if ($presence.attr('type') !== 'error' && !VeedoChat.joined) {
                // check for status 110 to see if it's our own presence
                if ($presence.find("status[code='110']").length > 0) {
                    // check if server changed our nick
                    if ($presence.find("status[code='210']").length > 0) {
                        VeedoChat.myuuid = Strophe.getResourceFromJid(from);
                    }

                    // room join complete
                    $(document).trigger("room_joined");
                }
            }
        } else if (VeedoChat.lobby && troom === VeedoChat.lobbyroom) {
            // ww're in the lobby!  ;-)
            if ($presence.find("status[code='110']").length > 0) {
                // check if server changed our nick
                if ($presence.find("status[code='210']").length > 0) {
                    VeedoChat.myuuid = Strophe.getResourceFromJid(from);
                    var lkey = "veedouuid" + name;
                    localStorage[lkey] = VeedoChat.myuuid;                    
                }

                // room join complete
                //$(document).trigger("room_joined");
                console.log("Waiting in the lobby!");
            }
        }

        return true;
    },

    checkNick(nick, message){
        try {
            var nicksub = $(message).children('nick').text();
            if (nicksub != ""){
                VeedoChat.nicks[nick] = nicksub;
            }
        } catch (anye) {
        }
    },

    on_public_message: function (message) {
        console.log(`veedoplayer.js:: VeedoChat::on_public_message(message), message = `, message);
        var from = $(message).attr('from');
        var troom = Strophe.getBareJidFromJid(from);
        var nick = Strophe.getResourceFromJid(from);
        var mid = $(message).attr('id');

        // make sure message is from the right place
        if (troom === VeedoChat.room) {
            var body = $(message).children('body').text().trim();
            VeedoChat.checkNick(nick, message);

            if (body.startsWith("/remx ")){
                // this is a moderator message
                var mid2 = body.substr(6);
                setTimeout(function(){
                    $("#"+mid2).remove();   //  9b69161e-1535-4c5b-baae-1b9edb2ffaaf
                } ,0); 
            } else if (nick && body != ""){
                // group/room messages do not have a nick here
                VeedoChat.add_message( nick, body, mid);
            }
        }

        return true;
    },

    add_message: function (from, msg, mid) {
        var fromout = "";
        if (VeedoChat.nicks[from]){
            fromout = VeedoChat.nicks[from];
        }
        document.dispatchEvent(new CustomEvent(`chat-message`, {
            bubbles: true, detail: {
                date: ((`undefined`==typeof v3) ? new Date() : new Date(v3)),
                from: fromout,
                text: msg,
                mid: mid
            }
        }));

    },

    on_private_message: function (message) {
        var from = $(message).attr('from');
        var troom = Strophe.getBareJidFromJid(from);
        var nick = Strophe.getResourceFromJid(from);

        // make sure this message is from the correct room
        if (troom === VeedoChat.room) {
            VeedoChat.checkNick(nick, message);

            var body = $(message).children('body').text();
            if (body.trim() != ""){
                VeedoChat.add_message(nick, "Privately to you: "+body);
            }
            var subject = $(message).children('subject').text();
            if (subject.trim() != ""){
                // set our subject here!
            }
        }

        return true;
    }
};

var exclusions = ["focus", "jibri"];
var joined = [];


$(document).bind('user_left', function (ev, nick) {
    let nn = VeedoChat.nicks[nick]||nick;

    if (exclusions.indexOf(nn) == -1){
        //VeedoChat.add_message("", stripStar(VeedoChat.nicks[nick]||nick) + " left");
    }
});

$(document).bind('user_joined', function (ev, nick) {
    let nn = VeedoChat.nicks[nick]||nick;
    if (exclusions.indexOf(nn) == -1 && joined.indexOf(nn) == -1){
        //VeedoChat.add_message("", stripStar(nn) + " joined");
        joined.push(nn);
    }
});

$(document).bind('room_joined', function (ev, nick) {
    VeedoChat.joined = true;
    VeedoChat.add_message("", " Welcome " + stripStar(VeedoChat.nickname));
});


function uuidv4() {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}
function uuidshort() {
    return uuidv4().substr(0,8);
}
    
/**
 * That function is called when connection is established successfully
 */
function onConnectionSuccess() {
    console.log(`veedoplayer.js - onConnectionSuccess()`);
    console.log(`options = `, options);
    $("#subject").html(roomName);

    VeedoChat.joined = false;
    VeedoChat.participants = {};
    VeedoChat.nicks = {};

    VeedoChat.connection.send($pres().c('priority').t('-1'));
    VeedoChat.connection.addHandler(VeedoChat.on_presence, null, "presence");
    VeedoChat.connection.addHandler(VeedoChat.on_public_message, null, "message", "groupchat");
    VeedoChat.connection.addHandler(VeedoChat.on_private_message, null, "message", "chat");
    var myuuid = uuidshort();
    var lkey = "veedouuid" + name;
    if (localStorage[lkey]){
        console.log(`using retrieved veedouuid: `, myuuid);
        myuuid = localStorage[lkey];
    } else {
        localStorage[lkey] = myuuid;
    }
    VeedoChat.myuuid = myuuid;
    VeedoChat.nickname = name;
    VeedoChat.nicks[VeedoChat.myuuid] = name;
    VeedoChat.room = roomName + "@" + options.hosts.muc;
    //console.log(`veedoplayer.js - sending sendPresence( .. )`, VeedoChat.room);
    sendPresence(VeedoChat.room);
}

function resetVeedoUUID() {
    localStorage.removeItem(`veedouuid${name}`);
}

function sendPresence(troom) {
    var pres =  $pres({
        to: troom + "/" + VeedoChat.myuuid
    });
    pres.c('x', {xmlns: VeedoChat.NS_MUC});
    // add nickname using proper namespace
    pres.up().c('nick', {xmlns: VeedoChat.NS_NICK}).t(VeedoChat.nickname);
    VeedoChat.connection.send(pres);
}

function streamingChanged(evt){
    console.log(`veedoplayer.js : streamingChanged(evt): evt=`, evt);
    if (window.DisableVeedoPlayer) {
        console.log(`veedoplayer.js::streamingChanged: DisableVeedoPlayer= true`);
        return;
    }
    if (!VeedoChat.joined){
        console.log("veedoplayer.js : streamingChanged() - Sorry - Not joined as yet!");
        return;
    } else {
        console.log("veedoplayer.js : streamingChanged() - Ok - joined!");
    }
    if (evt && evt._mode && evt._mode == "stream" && evt._status=="on"){
        // we have started streaming
        streaming = true; // no coming back from this!
        startPlayer();
    } else if (evt && evt._mode && evt._mode == "stream" && evt._status=="off"){
        // we have stopped streaming
        disconnect();
        let idiv = $("<div>").attr("id","leftplaceholderinner");
        idiv.html("Your conference is ending soon..");
        $("#leftplaceholder").empty().append(idiv);
        setTimeout(() => {
            stopPlayer();
            idiv.html("Your conference has ended.");
        }, 10000);
    }
}

function sendMessage(input) {
    // console.log(input.value);
    var txt = input.value + "";
    if (txt.trim() == "")
        return;
    var msg = $msg({
        to: VeedoChat.room,
        id: uuidshort(),
        type: "groupchat"})
    .c('body').t(txt.trim());
    msg.up().c('nick', {xmlns: VeedoChat.NS_NICK}).t(VeedoChat.nickname);

    VeedoChat.connection.send(msg);
    input.value = "";
}

window.SendChatMessageFromInput = sendMessage;

/**
 * This function is called when the connection fails.
 */
function onConnectionFailed() {
    console.error('veedoplayer.js::onConnectionFailed() : Connection Failed!');
}

/**
 * This function is called when we disconnect.
 */
function disconnect() {
    unload();
}

function unload() {
    if (VeedoChat.connection) {
        VeedoChat.connection.disconnect();
        VeedoChat.connection = null;
    }
    console.log(`veedoplayer.js ========================= UNLOADED ==================`);
}

//$(window).bind('beforeunload', unload);
$(window).bind('unload', unload);

let connection = null;
let conference = null;
let room = null;
let users = [];
var name = "";
var streaming = false;

// mergeObjects merges two javascript objecst such that the 
// return value will have all the values in the parameter objects, with 
// values from the first parameter overriding the values from the second
// parameter.
function mergeObjects(sourcea, sourceb) {
    if (`undefined`==typeof sourcea) sourcea = {};
    if (`undefined`==typeof sourceb) sourceb = {};
    let r = {};    
    // turn the order around because A trumps B
    Object.assign(r, sourceb, sourcea);
    for (let a in r) {
        if (`object`==typeof(r[a])) {
            r[a] = mergeObjects(sourcea[a], sourceb[a]);
        }
    }
    return r;
}

document.addEventListener(`DOMContentLoaded`, function() {
    var fulldomain = `veedo.chat`;
    if (`undefined` != typeof(window.subdomain) && `undefined`!=typeof(window.domane)) {
        fulldomain = subdomain + domane;
    }
    // console.log(`veedoplayer.js: DOMContentLoaded() - setting options`);
    // We're going to merge fulldomain/subdomain/domane based 
    // values with a possibly existing window['options'] object
    window[`options`] = mergeObjects(window[`options`], 
        {
            hosts: {
                domain: ''+fulldomain+'',
                muc: 'conference.'+fulldomain+'', 
                anonymousdomain: 'guest.'+fulldomain+''
            },
            bosh: '//'+fulldomain+'/http-bind', 
        });
    // console.log(`window.options = `, options);
    new UserLogger();
    document.addEventListener(`veedo-user-name`, function() {
        actuallyStartJitsi();
    });
    $(document).bind('connected', onConnectionSuccess);
    $(document).bind('connectfail', onConnectionFailed);
    $(document).bind('disconnected', unload);
    console.log(`veedoplayer::DOMContentLoaded. Calling changeName(true)`);
    changeName(true);
});

document.addEventListener(`veedo-login-failed`, function() {
    console.log(`veedoplayer::DOMContentLoaded. Calling changeName(true)`);
    changeName(true, true);
});


function stropheStatus(status, err) {
    if (err) {
        console.log(err);
    }
    if (status=== Strophe.Status.ERROR){
        console.log("stropheStatus: Status.ERROR");
        console.log(`stropheStatus: err = `, err);
    }
    if (status=== Strophe.Status.CONNECTING){
        console.log("Status.CONNECTING");
    }
    if (status=== Strophe.Status.CONNFAIL){
        console.log("Status.CONNFAIL");
        $(document).trigger('connectfail');
    }
    if (status=== Strophe.Status.AUTHENTICATING){
        console.log("Status.AUTHENTICATING");
    }
    if (status=== Strophe.Status.AUTHFAIL){
        console.log("Status.AUTHFAIL");
    }
    if (status=== Strophe.Status.CONNECTED){
        console.log("Status.CONNECTED");
        $(document).trigger('connected');
    }
    if (status=== Strophe.Status.DISCONNECTED){
        // console.log("Status.DISCONNECTED");
        if (VeedoChat.reconnect_after_disconnection) {
            VeedoChat.reconnect_after_disconnection = false;
            // console.log(`veedoplayer.js stropheStatus: DISCONNECTED and restarting strophe connection w/ reset`);
            VeedoChat.connection.reset();
            resetVeedoUUID();
            setTimeout(actuallyStartJitsi, 2000);
        } else {
            $(document).trigger('disconnected');
        }
    }
    if (status=== Strophe.Status.DISCONNECTING){
        // console.log("Status.DISCONNECTING");
    }
    if (status=== Strophe.Status.ATTACHED){
        console.log("Status.ATTACHED");
    }
}

function actuallyStartJitsi() {
    if (!AmbiguousHasProperty(veedoConfig, `chat`)) {
        console.log(`actuallyStartJitsi returning without starting chat because AmbiguousHasProperty(cfg, 'chat') returned false`);
        return;
    }
    if (document.body.hasAttribute(`data-no-strophe`)) {
        console.log(`Not starting strophe since document.body has @data-no-strophe attribute`);
    } else {
        console.log(`veedoplayer.js::actuallyStartJitsi() starting Strophe options.bosh=`, options.bosh);
        VeedoChat.connection = new Strophe.Connection(options.bosh);
        VeedoChat.connection.connect(options.hosts.anonymousdomain, '', stropheStatus);
    }
}


var player = null;

function startPlayer() {
    $("#player").show();
    if (player == null){
        try {
            player = videojs('#player', {
                autoplay: 'play',
                liveui: true
            });
        } catch (e){
            console.error(e);
        }        
    }
}

function stopPlayer() {
    player.dispose();
    player = null;
}
